(function (global) {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';
    var controller = new AbortController(), options = {signal:controller.signal};
    root.cpRecipeController = controller;
    var memory = global.CPStorefrontMemory;
    if (!memory) {var sessionRecipes=[];memory={recipes:function(){return sessionRecipes.slice();},saveRecipe:function(item){sessionRecipes=sessionRecipes.filter(function(x){return x.key!==item.key;});sessionRecipes.push(item);},removeRecipe:function(key){sessionRecipes=sessionRecipes.filter(function(x){return x.key!==key;});},isPersistent:function(){return false;}};}
    var activeFilter = 'all', search=root.querySelector('[data-recipe-search]'), count=root.querySelector('[data-recipe-count]'), style=new URL(location.href).searchParams.get('style')||'';
    var styles = new Set(Array.from(root.querySelectorAll('[data-recipe-style]')).flatMap(function(card){return String(card.dataset.recipeStyle||'').split(/[,\s]+/).filter(Boolean);}));
    if(!styles.has(style))style='';
    if(search)search.addEventListener('input',applyFilter,options);
    var status = root.querySelector('[data-cp-recipe-status]');

    function announce(message) {
      if (status) status.textContent = message;
    }

    function savedKeys() {
      return memory.recipes().map(function (item) { return item.key; });
    }

    function applyFilter() {
      var keys = savedKeys();
      root.querySelectorAll('.cp-recipe').forEach(function (card) {
        var hidden = activeFilter === 'saved'
          ? keys.indexOf(card.dataset.recipeKey) === -1
          : activeFilter !== 'all' && card.dataset.category !== activeFilter;
        var term=search?search.value.trim().toLowerCase():'';
        hidden=hidden||(term&&!card.textContent.toLowerCase().includes(term))||(style&&!String(card.dataset.recipeStyle||'').split(/[,\s]+/).includes(style));
        card.classList.toggle('is-hidden', !!hidden);
      });
      if(count){var n=root.querySelectorAll('.cp-recipe:not(.is-hidden)').length;count.textContent=n?n+(n===1?' recipe to explore':' recipes to explore'):'No matching recipes. Clear the search or choose All.';}
    }

    function paint() {
      var keys = savedKeys();
      root.querySelectorAll('.cp-recipe').forEach(function (card) {
        var isSaved = keys.indexOf(card.dataset.recipeKey) > -1;
        var button = card.querySelector('[data-recipe-save]');
        if (!button) return;
        button.classList.toggle('is-saved', isSaved);
        button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
        button.textContent = isSaved ? (memory.isPersistent()?'Saved on this device ✓':'Saved for this visit ✓') : 'Save recipe';
      });
      applyFilter();
    }

    try {
      var legacyText = global.localStorage.getItem('cp_recipe_saves_v1') || '[]';
      var legacy = legacyText.length<=40000?JSON.parse(legacyText):[];
      if (Array.isArray(legacy)) {
        var migrated = [];
        root.querySelectorAll('.cp-recipe').forEach(function (card) {
          if (legacy.indexOf(card.dataset.recipeKey) > -1) {
            if(savedKeys().indexOf(card.dataset.recipeKey) === -1) memory.saveRecipe({ key: card.dataset.recipeKey, title: card.dataset.recipeTitle, url: card.dataset.recipeUrl, image: card.dataset.recipeImage || '' });
            if(memory.isPersistent()&&savedKeys().indexOf(card.dataset.recipeKey)>-1)migrated.push(card.dataset.recipeKey);
          }
        });
        if(migrated.length){var remaining=legacy.filter(function(key){return !migrated.includes(key);});if(remaining.length)global.localStorage.setItem('cp_recipe_saves_v1',JSON.stringify(remaining));else global.localStorage.removeItem('cp_recipe_saves_v1');}
      }
    } catch (error) {}

    root.querySelectorAll('[data-filter]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
      button.addEventListener('click', function () {
        root.querySelectorAll('[data-filter]').forEach(function (item) {
          var selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        activeFilter = button.dataset.filter;style='';
        applyFilter();
        if (global.CPAnalytics) global.CPAnalytics.track('cp_recipe_filter', { recipe_filter: activeFilter });
      },options);
    });

    root.querySelectorAll('[data-recipe-save]').forEach(function (button) {
      button.addEventListener('click', function () {
        var card = button.closest('.cp-recipe');
        var key = card.dataset.recipeKey;
        var isSaved = savedKeys().indexOf(key) > -1;
        if (isSaved) memory.removeRecipe(key);
        else memory.saveRecipe({ key: key, title: card.dataset.recipeTitle, url: card.dataset.recipeUrl, image: card.dataset.recipeImage || '' });
        paint();
        announce(isSaved ? memory.isPersistent()?'Recipe removed from your saved recipes.':root.dataset.recipeRemovedVisit||'Recipe removed for this visit. Your browser could not update its saved list.' : memory.isPersistent()?'Recipe saved on this device.':'Recipe saved for this visit.');
        if (global.CPAnalytics) global.CPAnalytics.track('cp_recipe_save', { recipe: key, saved: !isSaved, storage: memory.isPersistent() ? 'device' : 'session' });
      },options);
    });

    root.querySelectorAll('[data-recipe-caption]').forEach(function (button) {
      button.addEventListener('click', async function () {
        try {
          await navigator.clipboard.writeText(button.dataset.caption || '');
          announce('Caption copied.');
          var old = button.textContent;
          button.textContent = 'Copied ✓';
          global.setTimeout(function () { button.textContent = old; }, 1400);
        } catch (error) {
          announce('Copy was unavailable. Select the recipe title and summary instead.');
        }
      },options);
    });

    root.querySelectorAll('[data-recipe-share]').forEach(function (button) {
      button.addEventListener('click', async function () {
        var card = button.closest('.cp-recipe');
        var title = card.dataset.recipeTitle || 'Café Perfection recipe';
        var publicLink = new URL(global.location.pathname, global.location.origin);publicLink.hash=card.id;
        var url = publicLink.href;
        try {
          if (navigator.share) await navigator.share({ title: title, text: title + ' · Café Perfection', url: url });
          else {
            await navigator.clipboard.writeText(title + ' ' + url);
            announce('Recipe link copied.');
          }
          if (global.CPAnalytics) global.CPAnalytics.track('cp_recipe_share', { recipe: card.dataset.recipeKey });
        } catch (error) {
          if (error && error.name !== 'AbortError') announce('Sharing is unavailable in this browser.');
        }
      },options);
    });

    document.addEventListener('cp:memory:change', paint,options);
    paint();
  }

  function start() {
    document.querySelectorAll('[data-cp-recipes]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) {
    if(event.target.matches('[data-cp-recipes]'))init(event.target);
    event.target.querySelectorAll('[data-cp-recipes]').forEach(init);
  });
  document.addEventListener('shopify:section:unload', function(event){var roots=event.target.matches('[data-cp-recipes]')?[event.target]:Array.from(event.target.querySelectorAll('[data-cp-recipes]'));roots.forEach(function(root){root.cpRecipeController?.abort();delete root.dataset.ready;});});
})(window);
